import { SPEED_INSANE, SPEED_HARD, SPEED_FAST, SPEED_MIDDLE, SPEED_SLOW, randomTo } from "../../engine/consts"

export const TYPES = {
    'usualBag': (props) => usualBag(props),
    'forceBag': (props) => forceBag(props),
    'bazed': (props) => bazed(props),
    'speeder': (props) => speeder(props),
    'spices': (props) => spices(props),
    'gigo': (props) => gigo(props),
    
    
    'splitter': (props) => splitter(props),
    'forceMathBag': (props) => forceMathBag(props),
}


const usualBag = (props) => {
    return {
        name: 'Обычная груша',
        subname: 'Обычный',
        discription: 'Просто груша, не отбивается',
        // lives: 6,
        lives: 2, // для тестов
        force: 0,
        attackStrategy: 'random',
        attackType: 'snow',
        attackView: 'no', // как выглядит
        headType: 'cup',
        armorType: {
            //     1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
            //     2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] },
            //     3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] }
            1: { type: 'usual', material: 'snow' },
            2: { type: 'usual', material: 'snow' },
            3: { type: 'usual', material: 'snow' }
        },
        attackInner: SPEED_MIDDLE,
        attackSpeed: 1,
        attackGreedLeft: 1,
        attackGreedRight: 3,
        innerLvl: 1,
        steps: [1, 1, 1]
    }
}

const forceBag = (props = {}) => {

    const { lvl = 1 } = props;

    const allParam = {
        name: 'Ударный груша',
        discription: 'Груша, которая и ударить может',
        attackStrategy: 'random',
        attackView: 'snow', // как выглядит
        attackType: 'snow',
        headType: 'cup',
        armorType: {
            1: { type: 'usual', material: 'snow' },
            2: { type: 'usual', material: 'snow' },
            3: { type: 'usual', material: 'snow' }
        },
        attackInner: SPEED_MIDDLE,
        steps: [1, 2, 1, 2]
    }

    if (lvl === 1) {
        return {
            subname: 'Обычный',
            lives: 8,
            force: 2,
            innerLvl: 1,

            ...allParam,

            attackSpeed: 10,
            attackGreedLeft: 2,
            attackGreedRight: 2
        }
    }
    return null;
}

const forceMathBag = (props = {}) => {

    const { lvl = 1 } = props;
    if (lvl === 1) {
        return {
            name: 'Ударный груша',
            subname: 'Обычный',
            discription: 'Груша, которая и ударить может',
            lives: 8,
            force: 2,
            attackStrategy: 'random',
            attackView: 'math', // как выглядит
            attackType: 'math',
            headType: 'math',
            armorType: {
                1: { type: 'usual', material: 'snow' },
                2: { type: 'usual', material: 'snow' },
                3: { type: 'usual', material: 'snow' }
            },
            attackInner: SPEED_SLOW,
            attackSpeed: 1,
            attackGreedLeft: 1,
            attackGreedRight: 3,

            innerLvl: 1,

            steps: [1, 2, 1, 2]
        }
    }
    if (lvl === 2) {
        return {
            name: 'Ударный груша',
            subname: 'Бугай',
            discription: 'Груша, которая и ударить может',
            lives: 12,
            force: 3,
            attackStrategy: 'random',
            attackType: 'snow', // как выглядит
            attackView: 'snow',
            headType: 'usual',
            armorType: {
                1: { type: 'usual', material: 'snow' },
                2: { type: 'usual', material: 'snow' },
                3: { type: 'usual', material: 'snow' }
            },
            attackInner: SPEED_MIDDLE,
            attackSpeed: 2,
            attackGreedLeft: 1,
            attackGreedRight: 3,

            innerLvl: 2,

            steps: [1, 2, 2, 1, 2]
        }
    }
    return null;
}

const bazed = (props = {}) => {

    const { lvl = 1 } = props;

    const allParam = {
        name: 'Базовичок',
        discription: 'Самый такой базовичок, имеет броню, которую надо разбить',
        attackStrategy: 'random',
        attackView: 'snow', // как выглядит
        attackType: 'snow',
        headType: 'usual',
        armorType: {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
            2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] }
        },
        attackInner: SPEED_FAST,
        steps: [1, 2, 2, 1, 2],
        attackGreedLeft: 2,
        attackGreedRight: 2
    }

    if (lvl === 2) {
        return {
            lives: 8,
            force: 3,
            innerLvl: 2,
            ...allParam,
            attackSpeed: 12,
        }
    }
    if (lvl === 3) {
        return {
            lives: 10,
            force: 4,
            innerLvl: 3,
            ...allParam,
            armorType: {
                1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
                2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] },
                3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] }
            },
            attackSpeed: 14,
        }
    }
    if (lvl === 4) {

        let armorType = {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 4, hp: 4 }] },
            2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 4, hp: 4 }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 4, hp: 4 }] }
        }

        let inner = randomTo(1, 3)
        armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        if (randomTo(0, 1)) {
            inner = randomTo(1, 3)
            armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        }

        return {
            lives: 12,
            force: 5,
            innerLvl: 4,
            ...allParam,
            attackInner: SPEED_FAST,
            armorType,
            attackSpeed: 16,
        }
    }
    if (lvl === 5) {

        let armorType = {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 5, hp: 5 }] },
            2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 5, hp: 5 }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 5, hp: 5 }] }
        }

        let inner = randomTo(1, 3)
        armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        if (randomTo(0, 1)) {
            inner = randomTo(1, 3)
            armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        }


        return {
            lives: 15,
            force: 7,
            innerLvl: 5,
            ...allParam,
            armorType,
            attackInner: SPEED_HARD,
            attackSpeed: 18,
        }
    }

}

const bazedOld = (props = {}) => {

    const { lvl = 1 } = props;
    if (lvl === 1) {
        return {
            name: 'Базовичок',
            subname: 'Обычный',
            discription: 'Самый такой базовичок',
            lives: 7,
            force: 3,
            attackStrategy: 'random',
            attackView: 'snow', // как выглядит
            attackType: 'snow',
            headType: 'usual',
            armorType: {
                1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
                2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] },
                3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] }
            },
            attackInner: SPEED_SLOW,
            attackSpeed: 2,
            attackGreedLeft: 1,
            attackGreedRight: 2,

            extrasStrategyCore: {
                everyStart: [
                    { cmd: 'addBuff', blockNum: 3, buffId: 'speed_1' }, //blockNum от 1
                ]
            },
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras: [
                { id: 'speed_1', type: 'sn_speed', innerLeft: 3, speedShift: -2, immediately: true, useOnlyAtStart: true }
            ],
            buffs: [
            ],

            innerLvl: 2,

            // steps: [1, 2, 1, 2, 2]

            steps: [1, 2, 2, 2, 1]
        }
    }
    if (lvl === 2) {
        let innerLeft = 2 + randomTo(1, 2);
        let steps = [1];
        let wasPlayer = false;
        for (let i = 0; i < 4; i++) {

            if (i === 3 && !wasPlayer) {
                steps.push(1);
                break;
            }

            if (wasPlayer) {
                steps.push(2);
                continue;
            }

            let a = randomTo(1, 3);
            if (a === 1) {
                steps.push(1);
                wasPlayer = true;
            } else {
                steps.push(2);
            }
        }

        let extras = [];
        let attackInner = 0;
        let blockNum = randomTo(2, 5);

        attackInner = SPEED_FAST;
        extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedShift: -1, immediately: true, useOnlyAtStart: true })

        // if (randomTo(0, 1)) {
        //     attackInner = SPEED_FAST;
        //     extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedShift: -1, immediately: true, useOnlyAtStart: true })
        // } else {
        //     attackInner = SPEED_SLOW;
        //     extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedTo: SPEED_HARD, immediately: true, useOnlyAtStart: true })
        // }

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockNum, buffId: 'speed_1' } //blockNum от 1
            ]
        }

        let armorType = {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] },
            2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 2, hp: 2 }] }
        }


        let inner = randomTo(1, 3)
        armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        if (randomTo(0, 1)) {
            inner = randomTo(1, 3)
            armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        }
        return {
            name: 'Базовичок',
            subname: 'Обычный',
            discription: 'Самый такой базовичок',
            lives: 5,
            force: 4,
            attackStrategy: 'random',
            attackView: 'snow', // как выглядит
            attackType: 'snow',
            headType: 'usual',
            armorType,
            attackInner,
            attackSpeed: 3,
            attackGreedLeft: 1,
            attackGreedRight: 2,

            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],

            innerLvl: 3,
            steps
        }
    }



    return null;
}

const speeder = (props = {}) => {

    const { lvl = 1 } = props;
    let extras = [];

    const allParam = {
        name: 'Скоростной',
        discription: "Умеет разгонять скорость атаки",
        attackStrategy: 'random',
        attackView: 'snow', // как выглядит
        attackType: 'snow',
        headType: 'flash',
        armorType: {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
            2: { type: 'usual', material: 'flash', uppers: [{ type: 'inner' }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        },
        attackInner: SPEED_MIDDLE,
        steps: [1, 2, 2, 2, 1],
        attackGreedLeft: 2,
        attackGreedRight: 2
    }

    if (lvl === 2) {
        const innerLeft = 2;
        const speedShift = -2;
        const blockNum = randomTo(2, 3);
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })
        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockNum, buffId: 'speed_1' }, //blockNum от 1
            ]
        }
        return {
            lives: 12,
            force: 3,
            innerLvl: 2,
            ...allParam,
            attackSpeed: 12,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }
    if (lvl === 3) {
        const innerLeft = 2;
        const speedShift = -2;
        const blockNum = randomTo(1, 3);
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [1], damage: 3, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'speed_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 80 } //blockNum от 1
            ]
        }
        return {
            lives: 15,
            force: 4,
            innerLvl: 3,
            ...allParam,
            attackSpeed: 14,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }
    if (lvl === 4) {
        const innerLeft = 2;
        const speedShift = -3;
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [1], damage: 4, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'speed_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 80 } //blockNum от 1
            ]
        }
        return {
            lives: 18,
            force: 5,
            innerLvl: 4,
            ...allParam,
            attackSpeed: 17,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            armorType: {
                1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
                2: { type: 'usual', material: 'flash', uppers: [{ type: 'inner' }] },
                3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 5, hp: 5 }] }
            },
            extras,
            buffs: [
            ],
        }
    }
    if (lvl === 5) {
        const innerLeft = 2;
        const speedShift = -3;
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [1], damage: 5, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'speed_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 80 } //blockNum от 1
            ]
        }
        return {
            lives: 23,
            force: 5,
            innerLvl: 5,
            ...allParam,
            attackSpeed: 20,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            armorType: {
                1: { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] },
                2: { type: 'usual', material: 'flash', uppers: [{ type: 'inner' }] },
                3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 5, hp: 5 }] }
            },
            extras,
            buffs: [
            ],
        }
    }

}

const spices = (props = {}) => {
    const { lvl = 1 } = props;
    let extras = [];

    const allParam = {
        name: 'Шипованный',
        discription: "Умеет выпускать шипы, куда нельзя бить",
        attackStrategy: 'random',
        attackView: 'snow', // как выглядит
        attackType: 'snow',
        headType: 'spices',
        armorType: {
            1: { type: 'usual', material: 'spices', uppers: [{ type: 'inner' }] },
            2: { type: 'usual', material: 'spices', uppers: [{ type: 'inner' }] },
            3: { type: 'usual', material: 'spices', uppers: [{ type: 'inner' }] }
        },
        attackInner: SPEED_FAST,
        steps: [1, 2],
        attackGreedLeft: 2,
        attackGreedRight: 2
    }

    if (lvl === 2) {
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [], execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], damage: 5, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 100 } //blockNum от 1
            ]
        }
        return {
            lives: 14,
            force: 1,
            innerLvl: 2,
            ...allParam,
            attackSpeed: 12,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }

    if (lvl === 3) {
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [], execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], damage: 6, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 100 } //blockNum от 1
            ]
        }
        return {
            lives: 18,
            force: 2,
            innerLvl: 3,
            ...allParam,
            attackSpeed: 14,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }

    if (lvl === 4) {


        const innerLeft = 1;
        const speedShift = -2;

        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [], execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], damage: 8, immediately: true, useOnlyAtStart: true });
        extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'speed_1', sucess: 70 } //blockNum от 1
            ]
        }
        return {
            lives: 23,
            force: 3,
            innerLvl: 4,
            ...allParam,
            attackSpeed: 16,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }
    if (lvl === 5) {


        const innerLeft = 1;
        const speedShift = -2;

        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [], execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], damage: 10, immediately: true, useOnlyAtStart: true });
        extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedShift, immediately: true, useOnlyAtStart: true })

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'speed_1', sucess: 80 } //blockNum от 1
            ]
        }
        return {
            lives: 30,
            force: 4,
            innerLvl: 5,
            ...allParam,
            attackSpeed: 19,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }
}

const gigo = (props = {}) => {
    const { lvl = 3 } = props;
    let extras = [];

    const allParam = {
        name: 'Гигочад',
        discription: "Очень мощный, но медленный снеговик",
        attackStrategy: 'random',
        attackView: 'gigo', // как выглядит
        attackType: 'snow',
        headType: 'gigo',
        armorType: {
            1: { type: 'undamage', material: 'gigo' },
            2: { type: 'armor', material: 'gigo', armored: 0.9, uppers: [{ type: 'shield', armorName: 'armor1', hp: 3.3, innerHp: 3.3 }] },
            3: { type: 'usual', material: 'gigo', uppers: [{ type: 'inner' }] }
        },
        attackInner: SPEED_FAST,
        steps: [1, 2, 1, 2],
        attackGreedLeft: 1,
        attackGreedRight: 2
    }

    if (lvl === 3) {
        extras.push({ id: 'gigo_1', type: 'sn_gigo', innerLeft: 1, immediately: true, useOnlyAtStart: true });

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 75 } //blockNum от 1
                // { cmd: 'addBuff', blockNum: 2, buffId: 'gigo_1' } //blockNum от 1
            ]
        }
        return {
            lives: 9,
            force: 7,
            innerLvl: 3,
            ...allParam,
            attackSpeed: 12,
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }

    if (lvl === 4) {
        extras.push({ id: 'gigo_1', type: 'sn_gigo', innerLeft: 1, immediately: true, useOnlyAtStart: true });
        extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft: 1, speedShift: -1, immediately: true, useOnlyAtStart: true })

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 80 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 45 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'speed_1', sucess: 75 } //blockNum от 1
                // { cmd: 'addBuff', blockNum: 2, buffId: 'gigo_1' } //blockNum от 1
            ]
        }
        return {
            lives: 12,
            force: 9,
            innerLvl: 4,
            ...allParam,
            attackSpeed: 14,
            armorType: {
                1: { type: 'undamage', material: 'gigo' },
                2: { type: 'armor', material: 'gigo', armored: 0.9, uppers: [{ type: 'shield', armorName: 'armor1', hp: 4.3, innerHp: 4.3 }] },
                3: { type: 'usual', material: 'gigo', uppers: [{ type: 'inner' }] }
            },
            steps: [1, 2, 2, 1, 2],
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }

    if (lvl === 5) {
        extras.push({ id: 'gigo_1', type: 'sn_gigo', innerLeft: 1, immediately: true, useOnlyAtStart: true });
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft: 2, speedShift: -1, immediately: true, useOnlyAtStart: true })

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 90 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 65 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'speed_1', sucess: 80 } //blockNum от 1
                // { cmd: 'addBuff', blockNum: 2, buffId: 'gigo_1' } //blockNum от 1
            ]
        }
        return {
            lives: 16,
            force: 12,
            innerLvl: 5,
            ...allParam,
            armorType: {
                1: { type: 'undamage', material: 'gigo' },
                2: { type: 'armor', material: 'gigo', armored: 0.9, uppers: [{ type: 'shield', armorName: 'armor1', hp: 5.6, innerHp: 5.6 }] },
                3: { type: 'usual', material: 'gigo', uppers: [{ type: 'inner' }] }
            },
            attackSpeed: 17,
            steps: [1, 2, 2, 1, 2],
            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }
    if (lvl === 6) {
        extras.push({ id: 'gigo_1', unseen: true, type: 'sn_gigo', innerLeft: 1, immediately: true, useOnlyAtStart: true });
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft: 2, speedShift: -2, immediately: true, useOnlyAtStart: true })

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'gigo_1', sucess: 100 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'speed_1', sucess: 100 } //blockNum от 1
                // { cmd: 'addBuff', blockNum: 2, buffId: 'gigo_1' } //blockNum от 1
            ]
        }
        return {
            lives: 20,
            force: 15,
            innerLvl: 5,
            ...allParam,
            armorType: {
                1: { type: 'undamage', material: 'gigo' },
                2: { type: 'armor', material: 'gigo', armored: 0.9, uppers: [{ type: 'shield', armorName: 'armor1', hp: 7.2, innerHp: 7.2 }] },
                3: { type: 'usual', material: 'gigo', uppers: [{ type: 'inner' }] }
            },
            attackSpeed: 21,
            extrasStrategyCore,
            steps: [1, 2, 2, 1, 2],
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],
        }
    }

}


const splitter = (props = {}) => {

    const { lvl = 1 } = props;
    if (lvl === 1) {
        let innerLeft = 2 + randomTo(1, 2);
        let steps = [1];
        let wasPlayer = false;

        const stepsMax = 5;

        for (let i = 0; i < stepsMax; i++) {

            if (i === (stepsMax - 1) && !wasPlayer) {
                steps.push(1);
                break;
            }

            if (wasPlayer) {
                steps.push(2);
                continue;
            }

            let a = randomTo(1, 3);
            if (a === 1) {
                steps.push(1);
                wasPlayer = true;
            } else {
                steps.push(2);
            }
        }

        let extras = [];
        let attackInner = 0;
        let blockNum = randomTo(2, stepsMax + 1);

        // attackInner = SPEED_FAST;
        attackInner = SPEED_MIDDLE;
        extras.push({ id: 'speed_1', unseen: true, type: 'sn_speed', innerLeft, speedShift: -1, immediately: true, useOnlyAtStart: true })
        extras.push({ id: 'split_1', unseen: true, type: 'sn_split', innerLeft: 1, immediately: true, useOnlyAtStart: true })
        extras.push({ id: 'spices_1', unseen: true, type: 'sn_spices', innerLeft: 3, spicesAt: [], execCmd: [{ key: 'spiceSelect', spicesRandomTo: 2 }], damage: 3, immediately: true, useOnlyAtStart: true });
        // , unseen: true
        // if (randomTo(0, 1)) {
        //     attackInner = SPEED_FAST;
        //     extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedShift: -1, immediately: true, useOnlyAtStart: true })
        // } else {
        //     attackInner = SPEED_SLOW;
        //     extras.push({ id: 'speed_1', type: 'sn_speed', innerLeft, speedTo: SPEED_HARD, immediately: true, useOnlyAtStart: true })
        // }

        let extrasStrategyCore = {
            everyStart: [
                { cmd: 'addBuff', blockNum, buffId: 'speed_1' }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'anyMy', buffId: 'split_1', sucess: 80 }, //blockNum от 1
                { cmd: 'addBuff', blockStrategy: 'any', buffId: 'spices_1', sucess: 80 } //blockNum от 1
            ]
        }

        let armorType = {
            1: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] },
            2: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] },
            3: { type: 'usual', material: 'snow', uppers: [{ type: 'deflect', innerHp: 3, hp: 3 }] }
        }


        let inner = randomTo(1, 3)
        armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        if (randomTo(0, 1)) {
            inner = randomTo(1, 3)
            armorType[inner] = { type: 'usual', material: 'snow', uppers: [{ type: 'inner' }] }
        }
        return {
            name: 'Сплиттер',
            subname: 'Обычный',
            discription: 'Самый такой базовичок',
            lives: 6,
            force: 4,
            attackStrategy: 'random',
            attackView: 'snow', // как выглядит
            attackType: 'snow',
            headType: 'usual',
            armorType,
            attackInner,
            attackSpeed: 3,
            attackGreedLeft: 1,
            attackGreedRight: 2,

            extrasStrategyCore,
            extrasStrategy: {
                // 2: ['speed_1'] 
            },
            extras,
            buffs: [
            ],

            innerLvl: 3,
            steps
        }
    }



    return null;
}